import { Box, Stack, Typography, Container, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { isMobile } from "react-device-detect";
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';

function Services() {
  return (
    <Box id="services" sx={{ backgroundColor: "rgb(255, 255, 255);" }}>
      <Container sx={{ py: 4 }}>
        <Stack spacing={2} useFlexGap >
          <Typography variant="h4" component="h2">Våra tjänster</Typography>
          <Typography>Behöver din verksamhet hjälp med det lilla extra så vill vi gärna hjälpa er med detta!</Typography>
          <Typography>Tillsammans skräddarsyr vi koncept som lyfter och stärker din verksamhet! Du som redan är en del a Lokala Pärlor har dessutom 10%.</Typography>
          <Typography>För priser och mer information:</Typography>
          <Stack direction="row" alignItems="center" gap={1}>
            <PhoneIcon color="primary" />
            {isMobile
              ? <Typography
                variant="caption"
                component="a"
                href={`tel:+46733790742`}
                target="_blank">
                +46733790742
              </Typography>
              : <Typography variant="caption">+46733790742</Typography>
            }
          </Stack>
          <Stack direction="row" alignItems="center" gap={1}>
            <EmailIcon color="primary" />
            <Typography
              variant="caption"
              component="a"
              target="_top"
              rel="noopener noreferrer"
              href="mailto:info@lokalaparlor.com">
              info@lokalaparlor.com
            </Typography>
          </Stack>

        </Stack>
        <Box sx={{ paddingTop: 2 }}>
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography component="span">Event & paket</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>Vi hjälper dig och din verksamhet att sätta ihop och skräddarsy upplevelser som lyfter och stärker din verksamhet.</Typography>
              <Typography>För mer info, kontakta oss.</Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography component="span">Bröllop</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>Saknar din verksamhet en bröllopskoordinator?</Typography>
              <Typography>Vi hjälper gärna till med planering av bröllop. Allt från menyer, dukning och tema.</Typography>
              <Typography>För mer info, kontakta oss.</Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography component="span">Fest</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>Vi hjälper gärna din verksamhet med planering att skapa stämning, innehåll och helhetslösningar för tillställningar.</Typography>
              <Typography>För mer info, kontakta oss.</Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography component="span">Konferens</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>Behöver din verksamhet hjälp med helhetslösningar för konferenser eller olika konferenspaket?</Typography>
              <Typography>Vi hjälper gärna till och skräddarsyr vad som passar din verksamhet bäst, och även dina kunder.</Typography>
              <Typography>För mer info, kontakta oss.</Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography component="span">Meny</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>Vill du ha ett nytt meny-koncept?</Typography>
              <Typography>Vi skräddarsyr gärna olika menyer som passar din verksamhet efter säsong.</Typography>
              <Typography>För mer info, kontakta oss.</Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography component="span">Fotografering</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>Behöver du nya bilder till din websida, eller kanske filmat material?</Typography>
              <Typography>Då hjälper vi gärna till med detta.</Typography>
              <Typography>För mer info, kontakta oss.</Typography>
            </AccordionDetails>
          </Accordion>
        </Box>

      </Container>
    </Box>
  )
}

export default Services;